var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlackArrowBottom(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5292 8.96918C16.6696 9.1098 16.7485 9.30043 16.7485 9.49918C16.7485 9.69793 16.6696 9.88855 16.5292 10.0292L12.5292 14.0292C12.3886 14.1696 12.1979 14.2485 11.9992 14.2485C11.8004 14.2485 11.6098 14.1696 11.4692 14.0292L7.46918 10.0292C7.39549 9.96052 7.33639 9.87771 7.2954 9.78572C7.2544 9.69372 7.23236 9.5944 7.23059 9.4937C7.22881 9.393 7.24733 9.29297 7.28505 9.19958C7.32278 9.10619 7.37892 9.02136 7.45014 8.95014C7.52136 8.87892 7.60619 8.82278 7.69958 8.78505C7.79297 8.74733 7.893 8.72881 7.9937 8.73059C8.0944 8.73236 8.19372 8.7544 8.28571 8.7954C8.37771 8.83639 8.46051 8.89549 8.52918 8.96918L11.9992 12.4392L15.4692 8.96918C15.6098 8.82873 15.8004 8.74984 15.9992 8.74984C16.1979 8.74984 16.3886 8.82873 16.5292 8.96918Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackArrowBottom);
export default __webpack_public_path__ + "static/media/blackArrowBottom.f8e638611ff4ee222015400942fe4ff6.svg";
export { ForwardRef as ReactComponent };